import { z } from 'zod';

import { DATA_EXPORT_FORMATS } from './constants';

/**
 * Export types supported by the API
 */
export const exportTypeSchema = z.enum([
  'accounting_reference_activity_details',
  'accounting_references',
  'companies',
  'esg_details',
  'invoices',
  'site_activity_details',
  'product_prices',
  'sites',
  'supplier_overview',
  'user_activity_details',
  'users',
]);

/**
 * Validation schema for export parameters
 */
export const exportParametersSchema = z.object({
  filters: z
    .record(z.string(), z.unknown())
    .optional()
    .describe(
      'Filters expect same parameters as the search params of the route/query',
    ),
  format: z.enum(DATA_EXPORT_FORMATS),
  filename: z.string(),
});

/**
 * Validation schema for creating a data export job
 */
export const dataExportCreateRequestSchema = z.object({
  exportType: exportTypeSchema,
  parameters: exportParametersSchema.optional(),
  requestId: z.string().optional(),
});

/**
 * Validation schema for data export job creation response
 */
export const dataExportJobCreatedSchema = z.object({
  jobId: z.uuid(),
  requestId: z.string(),
});

/**
 * Validation schema for creating an invoice file export job.
 */
export const invoiceFileExportRequestSchema = z.object({
  invoiceIds: z.array(z.uuid()).min(1).max(500),
});

/**
 * Validation schema for an invoice file export job creation response.
 */
export const invoiceFileExportCreatedSchema = z.object({
  jobId: z.uuid(),
  requestId: z.string(),
});

/**
 * Validation schema for data export job result response
 */
export const dataExportResultRequestedSchema = z.object({
  errorCode: z.string().optional().nullable(),
  errorMessage: z.string().optional().nullable(),
  jobId: z.uuid(),
  requestId: z.string().optional(),
  sasUrl: z.url().optional().nullable(),
  skippedEntityIds: z.array(z.uuid()),
  status: z.enum([
    'pending',
    'processing',
    'in_progress',
    'completed',
    'failed',
  ]),
});
